import { useState } from 'react';

import constants from './constants.json';

import nearbyIcon from '../../images/icons/screens/coffee.svg';
import buildingIcon from '../../images/icons/screens/building.svg';
import wayfindingIcon from '../../images/icons/screens/paper-plane.svg';
import transitIcon from '../../images/icons/screens/transit.svg';
import weatherIcon from '../../images/icons/screens/weather.svg';
import transitTile from '../../images/content-library/transitscreen_tile.png';
import nearbyTile from '../../images/content-library/nearby_tile.png';
import wayfindingTile from '../../images/content-library/wayfinding_tile.png';
import weatherTile from '../../images/content-library/weather_tile.png';
import directoryTile from '../../images/content-library/directory_tile.png';

const IMAGE_MAP = {
    transitscreen: transitTile,
    nearby: nearbyTile,
    wayfinding: wayfindingTile,
    weather: weatherTile,
    directory: directoryTile
}

const ICON_MAP = {
    nearby: nearbyIcon,
    wayfinding: wayfindingIcon,
    directory: buildingIcon,
    transitscreen: transitIcon,
    weather: weatherIcon
}

const ActionfigureElements = ({ customerName, setIsOpenContentModal, selectCallback }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);

    const handleSelect = () => {
        selectCallback(constants.ACTIONFIGURE_ELEMENTS[selectedIndex]);
        setIsOpenContentModal(false);
    }

    return (
        <div className="ActionfigureElements">
            <div className="clm-content-header">
                <h2>{customerName}'s Actionfigure® Elements</h2>
                <button className="clm-close-btn" aria-label="Close Content library" onClick={() => setIsOpenContentModal(false)}>&times;</button>
            </div>
            <div className="clm-af-text">
                <p className="bold-text">Actionfigure® Elements are unique to each location.</p>
                <p>For example, if a playlist with Nearby is shared across two locations, each will display its own local Nearby content even though it's the same playlist.</p>
                <p>Actionfigure Elements appear on a Screen or Mobile only if they've been purchased for that location. If not, the slide will be skipped in the playlist.</p>
            </div>
            <div className="clm-content-slides">
                {
                    constants.ACTIONFIGURE_ELEMENTS.map((slide, idx) => (
                        <div
                            className={`clm-slide-container`}
                            key={idx}
                        >
                            <SlideItem slide={slide} image={IMAGE_MAP[slide.value] ? IMAGE_MAP[slide.value] : null} onClick={() => setSelectedIndex(idx)} />
                        </div>
                    ))
                }
            </div>
            <div className="clm-content-actions">
                <button
                        className="clm-action-btn"
                        onClick={() => window.open('https://actionfigure.ai/', '_blank', 'noopener,noreferrer')}
                    >
                        Learn more
                </button>
                <button className={`clm-action-btn ${selectedIndex === null || selectCallback === undefined ? 'disabled-button' : ''}`} disabled={selectedIndex === null || selectCallback === undefined} onClick={handleSelect}>Select</button>
            </div>
        </div>
    );
};

const SlideItem = ({ slide, image, onClick }) => {
    return (
        <div className="clm-slide-item" onClick={slide.label === 'TransitScreen' || slide.label === 'Nearby' ? onClick : null}>
             <img src={image} className="af-tile" />
        </div>
    );
};

export default ActionfigureElements;
